import React, { useId } from "react";
import {
  TextFieldStyled,
  DropDownStyled,
} from "@nike/nike-design-system-components";

/** Suppress NDS floating label; wireframe uses a static label above the control. */
function HiddenFloatingLabel() {
  return null;
}

function useFilterControlId(id, prefix) {
  const generated = useId().replace(/:/g, "");
  return id || `${prefix}-${generated}`;
}

/**
 * Wireframe-aligned filter dropdown (label above, single 34px bordered select).
 * Uses Nike DropDownStyled; styled via `.pg-filter-control` in palletGroupAssignment.css.
 */
export function PgFilterDropdown({
  label,
  id,
  name,
  className,
  options,
  value,
  onChange,
  disabled,
  error,
  errorMessage,
  ariaLive = "polite",
}) {
  const controlId = useFilterControlId(id, "pg-dd");

  return (
    <div className="pg-filter-field">
      {label ? (
        <label className="pg-filter-label" htmlFor={controlId}>
          {label}
        </label>
      ) : null}
      <DropDownStyled
        id={controlId}
        name={name || controlId}
        label={label}
        Label={HiddenFloatingLabel}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={error}
        errorMessage={errorMessage}
        autoComplete="off"
        ariaLive={ariaLive}
        className={["pg-filter-control", "pg-filter-dropdown", className]
          .filter(Boolean)
          .join(" ")}
      />
    </div>
  );
}

/**
 * Wireframe-aligned filter text field (label above, single 34px bordered input).
 */
export function PgFilterTextField({
  label,
  id,
  name,
  className,
  placeholder,
  value,
  onChange,
  disabled,
  error,
  errorMessage,
  ariaLive = "polite",
}) {
  const controlId = useFilterControlId(id, "pg-tf");

  return (
    <div className="pg-filter-field">
      {label ? (
        <label className="pg-filter-label" htmlFor={controlId}>
          {label}
        </label>
      ) : null}
      <TextFieldStyled
        id={controlId}
        name={name || controlId}
        label={label}
        Label={HiddenFloatingLabel}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        error={error}
        errorMessage={errorMessage}
        autoComplete="off"
        ariaLive={ariaLive}
        className={["pg-filter-control", "pg-filter-text", className]
          .filter(Boolean)
          .join(" ")}
      />
    </div>
  );
}

export function PgFilterActions({ children }) {
  return <div className="pg-filter-actions">{children}</div>;
}
